export function GetBaseCurrency(pair:string):string
{
    return pair.split("/")[1];
}